import React, { useState } from "react";
import { toast } from "react-toastify";
import { officerLogin } from "../common/officerAuth";

// Shown in place of the boot-install form until the officer signs in. Reuses
// the same officer-login endpoint (and accounts) as the mobile officer app.
const OfficerLoginForm = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const { name } = await officerLogin(email, password);
      toast.success(`Signed in as ${name}`);
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="panel panel-default" style={{ marginBottom: "15px" }}>
      <div className="panel-body">
        <h4 style={{ marginTop: 0 }}>Officer Sign In</h4>
        <p>Please sign in to confirm this boot installation.</p>
        <form onSubmit={submit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={submitting}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={submitting}
              required
            />
          </div>
          <button type="submit" className="btn btn-warning" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default OfficerLoginForm;
